import { render } from "./OpinionReview.vue?vue&type=template&id=0fea5d29&scoped=true"
import script from "./OpinionReview.vue?vue&type=script&lang=js"
export * from "./OpinionReview.vue?vue&type=script&lang=js"

import "./OpinionReview.vue?vue&type=style&index=0&id=0fea5d29&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fea5d29"]])

export default __exports__